import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="py-20 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Terms & Conditions</h1>
            <p className="text-slate-400 mb-8">Last updated: February 2026</p>
            
            <div className="prose prose-invert max-w-none space-y-8">
              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
                <p className="text-slate-300 leading-relaxed">
                  By accessing and using the TCUBE FITNESS website and services, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">2. Services Description</h2>
                <p className="text-slate-300 leading-relaxed">
                  TCUBE FITNESS provides online fitness coaching, personalized nutrition guidance, and health transformation programs. Our services are designed to support your health goals but are not a substitute for professional medical advice, diagnosis, or treatment.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">3. User Responsibilities</h2>
                <p className="text-slate-300 leading-relaxed mb-4">By using our services, you agree to:</p>
                <ul className="list-disc list-inside text-slate-300 space-y-2">
                  <li>Provide accurate and complete information about your health history and current conditions</li>
                  <li>Consult with your physician before starting any fitness or nutrition program</li>
                  <li>Follow the guidance provided by our coaches and medical team</li>
                  <li>Inform us of any changes in your health status</li>
                  <li>Not share your program materials with others</li>
                </ul>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">4. Health Disclaimer</h2>
                <p className="text-slate-300 leading-relaxed">
                  While our programs are designed under medical supervision, results may vary. You should always consult with a qualified healthcare provider before making changes to your diet or exercise routine, especially if you have existing health conditions.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">5. Payment Terms</h2>
                <p className="text-slate-300 leading-relaxed">
                  Payment for our services is due as per the package selected. All prices are in Indian Rupees (INR) unless otherwise specified. Payment methods and schedules will be communicated during enrollment.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">6. Intellectual Property</h2>
                <p className="text-slate-300 leading-relaxed">
                  All content, including workout plans, nutrition guides, and educational materials provided by TCUBE FITNESS, are our intellectual property. You may not copy, distribute, or share these materials without our written consent.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">7. Limitation of Liability</h2>
                <p className="text-slate-300 leading-relaxed">
                  TCUBE FITNESS shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. Our liability is limited to the amount paid for the services.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">8. Modifications</h2>
                <p className="text-slate-300 leading-relaxed">
                  We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Continued use of our services constitutes acceptance of the modified terms.
                </p>
              </section>

              <section className="bg-slate-900/50 rounded-2xl p-6 sm:p-8 border border-slate-800">
                <h2 className="text-xl font-semibold text-white mb-4">9. Contact Information</h2>
                <p className="text-slate-300 leading-relaxed">
                  For questions about these Terms and Conditions, please contact us at:
                </p>
                <p className="text-slate-300 mt-4">
                  <strong>Email:</strong> support@tcubefitness.com<br />
                  <strong>WhatsApp:</strong> +91 9515901777
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsPage;
